module.exports = __webpack_public_path__ + "img/cafe-leche2.1978b41e.jpeg";